"use strict";
// (C) 2007-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutItem = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var DashboardLayoutItemRenderer_1 = require("./DashboardLayoutItemRenderer");
var DashboardLayoutWidgetRenderer_1 = require("./DashboardLayoutWidgetRenderer");
var defaultItemRenderer = function (props) { return (react_1.default.createElement(DashboardLayoutItemRenderer_1.DashboardLayoutItemRenderer, tslib_1.__assign({}, props))); };
function DashboardLayoutItem(props) {
    var item = props.item, _a = props.itemRenderer, itemRenderer = _a === void 0 ? defaultItemRenderer : _a, widgetRenderer = props.widgetRenderer, screen = props.screen;
    var renderProps = {
        item: item,
        screen: screen,
        DefaultWidgetRenderer: DashboardLayoutWidgetRenderer_1.DashboardLayoutWidgetRenderer,
    };
    return itemRenderer(tslib_1.__assign(tslib_1.__assign({}, props), { DefaultItemRenderer: DashboardLayoutItemRenderer_1.DashboardLayoutItemRenderer, children: widgetRenderer(renderProps) }));
}
exports.DashboardLayoutItem = DashboardLayoutItem;
//# sourceMappingURL=DashboardLayoutItem.js.map